import * as ActionTypes from '../../constants/actiontypes/facilita/deathDeclaration';
import * as Loadings from '../../constants/loadings/facilita/deathDeclaration';
import * as R from 'ramda';
import DeathDeclaration from '../../constants/models/facilita/deathDeclaration';
import Letter from '../../constants/models/facilita/letter';
import Service from '../../constants/models/service';
import { toast } from 'react-toastify';
import DocumentFile from '../../constants/models/documentFile';
import Referent from '../../constants/models/referent';
import User from '../../constants/models/user';
import * as Text from '../../constants/toasterText/services';
import toastConf from '../../utils/toasterConfiguration';

import {convertConnectionTypesToServiceType} from '../../constants/utils/connectionTypes';
import {addressContractToInt, addressTypeToInt} from '../../utils/misc';


const DeathDeclarationReducer = (state = {
    isLoading: [],
    declaration: undefined,
    files: [],
    message: undefined,
    connectionTypes: [],
    serviceDatas:[],
    userLetters: [],
    referents: [],
    user: undefined,
    
}, action) => {
    switch(action.type){
        
        case ActionTypes.FETCH_DECLARATION_REQUEST:
            if (!state.isLoading.includes(Loadings.FETCHING_DECLARATION)){
                state.isLoading.push(Loadings.FETCHING_DECLARATION);
            }
            return { ...state };

        case ActionTypes.FETCH_DECLARATION_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.FETCHING_DECLARATION);
            if(R.isNil(action.data)){
                let declaration = new DeathDeclaration({});
                if(!R.isNil(action.defaultValues)){
                    declaration.firstName = action.defaultValues.firstName;
                    declaration.lastName = action.defaultValues.lastName;
                    declaration.processNumber = action.defaultValues.processNumber;
                }
                state.declaration =  declaration; 
            }else{
                state.declaration = new DeathDeclaration(action.data);     
            }
                  
            return { ...state };

        case ActionTypes.FETCH_DECLARATION_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.FETCHING_DECLARATION);
            return { ...state };
        

        case ActionTypes.CREATE_DECLARATION_REQUEST:
            if (!state.isLoading.includes(Loadings.CREATING_DECLARATION)){
                state.isLoading.push(Loadings.CREATING_DECLARATION);
            }
            return { ...state };

        case ActionTypes.CREATE_DECLARATION_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.CREATING_DECLARATION);
            
            state.declaration = new DeathDeclaration(action.data);           
            return { ...state };

        case ActionTypes.CREATE_DECLARATION_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.CREATING_DECLARATION);
            return { ...state };


        case ActionTypes.UPDATE_DECLARATION_REQUEST:
            if (!state.isLoading.includes(Loadings.UPDATING_DECLARATION)){
                state.isLoading.push(Loadings.UPDATING_DECLARATION);
            }
            return { ...state };

        case ActionTypes.UPDATE_DECLARATION_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.UPDATING_DECLARATION);
            state.declaration = new DeathDeclaration(action.data);
            return { ...state };

        case ActionTypes.FETCH_FILES_REQUEST:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.FETCHING_FILES);
            return { ...state };

        case ActionTypes.FETCH_FILES_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.FETCHING_FILES);
            state.files = action.data.map(d => new DocumentFile(d));
            return { ...state };

        case ActionTypes.DELETE_FILE_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.DELETING_FILE);
            state.files = state.files.filter(s => s.fileName !== action.data);
            return { ...state };

        case ActionTypes.UPLOAD_FILE_REQUEST:
            if (!state.isLoading.includes(Loadings.UPLOADING_FILE + action.documentName)){
                state.isLoading.push(Loadings.UPLOADING_FILE + action.documentName);
            }
            return { ...state };

        case ActionTypes.UPLOAD_FILE_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.UPLOADING_FILE + action.file.fileName);
            state.files.push(new DocumentFile(action.file))
            return { ...state };

        case ActionTypes.UPLOAD_FILE_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.UPLOADING_FILE + action.documentName);
            return { ...state };

        case ActionTypes.EDIT_DOCUMENT_SUCCESS:
            state.files =  state.files.map((document) => {
                if(document.fileName === action.file.fileName && document.fileType === action.file.fileType){
                    return new DocumentFile({ fileName: action.file.fileName, fileType: action.file.fileType, description: action.file.description });
                }
                return document;
            })
            return { ...state };

        case ActionTypes.SHARE_FILES_REQUEST:
            if (!state.isLoading.includes(Loadings.SHARING_FILES)){
                state.isLoading.push(Loadings.SHARING_FILES);
            }
            return { ...state };

        case ActionTypes.SHARE_FILES_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.SHARING_FILES);
            return { ...state };

        case ActionTypes.SHARE_FILES_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.SHARING_FILES);
            return { ...state };            

        case ActionTypes.FETCH_MESSAGE_REQUEST:
            if (!state.isLoading.includes(Loadings.FETCHING_MESSAGE)){
                state.isLoading.push(Loadings.FETCHING_MESSAGE);
            }
            return { ...state };

        case ActionTypes.FETCH_MESSAGE_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.FETCHING_MESSAGE);
            state.message = action.data;
            return { ...state };

        case ActionTypes.FETCH_USER_SERVICES_DATA_REQUEST:
            if (!state.isLoading.includes(Loadings.FETCHING_USER_SERVICES_DATA)){
                state.isLoading.push(Loadings.FETCHING_USER_SERVICES_DATA);
            }
            return { ...state };

        case ActionTypes.FETCH_USER_SERVICES_DATA_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.FETCHING_USER_SERVICES_DATA);
            state.serviceDatas = action.data;
            return { ...state };

        case ActionTypes.FETCH_USER_SERVICES_DATA_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.FETCHING_USER_SERVICES_DATA);
            return { ...state };

        case ActionTypes.CREATE_USER_SERVICES_DATA_REQUEST:
            if (!state.isLoading.includes(Loadings.CREATING_USER_SERVICES_DATA + "_" + action.serviceId)){
                state.isLoading.push(Loadings.CREATING_USER_SERVICES_DATA + "_" + action.serviceId);
            }
            return { ...state };

        case ActionTypes.CREATE_USER_SERVICES_DATA_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.CREATING_USER_SERVICES_DATA + "_" + action.serviceId);
            state.serviceDatas = state.serviceDatas.concat(action.data);
            toast.success(Text.addedSuccessfully, toastConf);
            return { ...state };

        case ActionTypes.CREATE_USER_SERVICES_DATA_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.CREATING_USER_SERVICES_DATA + "_" + action.serviceId);
            toast.error(Text.tryAddAgain, toastConf);
            return { ...state };

        case ActionTypes.UPDATE_USER_SERVICES_DATA_REQUEST:
            if (!state.isLoading.includes(Loadings.UPDATING_USER_SERVICES_DATA + "_" + action.id)){
                state.isLoading.push(Loadings.UPDATING_USER_SERVICES_DATA + "_" + action.id);
            }
            return { ...state };            
        case ActionTypes.UPDATE_USER_SERVICES_DATA_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.UPDATING_USER_SERVICES_DATA + "_" + action.id);
            state.serviceDatas = state.serviceDatas.map((service) => {
                if(service.id === action.data.id)
                    return {...service, ...action.data};

                return service;
            })
            toast.success(Text.updatedSuccessfully, toastConf);
            return { ...state };

        case ActionTypes.UPDATE_USER_SERVICES_DATA_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.UPDATING_USER_SERVICES_DATA + "_" + action.id);
            toast.error(Text.tryUpdateAgain, toastConf);
            return { ...state };

        case ActionTypes.DELETE_USER_SERVICES_DATA_REQUEST:
            if (!state.isLoading.includes(Loadings.DELETING_USER_SERVICES_DATA + "_" + action.id)){
                state.isLoading.push(Loadings.UPDATING_USER_SERVICES_DATA + "_" + action.id);
            }
            return { ...state };            
        case ActionTypes.DELETE_USER_SERVICES_DATA_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.DELETING_USER_SERVICES_DATA + "_" + action.id);
            state.serviceDatas = state.serviceDatas.filter(s => s.id !== action.id);
            toast.success(Text.deletedSuccessfully, toastConf);
            return { ...state };

        case ActionTypes.DELETE_USER_SERVICES_DATA_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.DELETING_USER_SERVICES_DATA + "_" + action.id);
            toast.error(Text.tryDeleteAgain, toastConf);
            return { ...state };

        case ActionTypes.GENERATE_USER_LETTERS_REQUEST:
            if (!state.isLoading.includes(Loadings.GENERATING_USER_LETTERS + "_" + action.userId)){
                state.isLoading.push(Loadings.GENERATING_USER_LETTERS + "_" + action.userId);
            }
            return { ...state };

        case ActionTypes.GENERATE_USER_LETTERS_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.GENERATING_USER_LETTERS + "_" + action.userId);
            return { ...state };

        case ActionTypes.GENERATE_USER_LETTERS_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.GENERATING_USER_LETTERS + "_" + action.userId);
            state.userLetters = action.data.map(l => new Letter(l)).filter((l, i, self) => self.findIndex(x => x.id === l.id) === i);
            return { ...state };

        case ActionTypes.GENERATE_USER_LETTER_REQUEST:
            if (!state.isLoading.includes(`${Loadings.GENERATING_USER_LETTERS}_${action.userId}_${action.userServiceId}`)){
                state.isLoading.push(`${Loadings.GENERATING_USER_LETTERS}_${action.userId}_${action.userServiceId}`);
            }
            return { ...state };

        case ActionTypes.GENERATE_USER_LETTER_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== `${Loadings.GENERATING_USER_LETTERS}_${action.userId}_${action.userServiceId}`);
            return { ...state };

        case ActionTypes.GENERATE_USER_LETTER_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== `${Loadings.GENERATING_USER_LETTERS}_${action.userId}_${action.userServiceId}`);
            state.userLetters = state.userLetters.concat(action.data.map(d => new Letter(d)));
            return { ...state };        
            
        case ActionTypes.FETCH_USER_LETTERS_REQUEST:
            if (!state.isLoading.includes(Loadings.FETCHING_USER_LETTERS + "_" + action.userId)){
                state.isLoading.push(Loadings.FETCHING_USER_LETTERS + "_" + action.userId);
            }
            return { ...state };
            
        case ActionTypes.FETCH_USER_LETTERS_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.FETCHING_USER_LETTERS + "_" + action.userId);
            return { ...state };

        case ActionTypes.FETCH_USER_LETTERS_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.FETCHING_USER_LETTERS + "_" + action.userId);
            state.userLetters = action.letters.map(l => new Letter(l)).filter((l, i, self) => self.findIndex(x => x.id === l.id) === i);
            return { ...state };
            
        case ActionTypes.UPDATE_USER_LETTER_REQUEST:
            if (!state.isLoading.includes(Loadings.UPDATING_USER_LETTER + "_" + action.userletterId)){
                state.isLoading.push(Loadings.UPDATING_USER_LETTER + "_" + action.userletterId);
            }
            return { ...state };
            
        case ActionTypes.UPDATE_USER_LETTER_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.UPDATING_USER_LETTER + "_" + action.userletterId);
            return { ...state };

        case ActionTypes.UPDATE_USER_LETTER_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.UPDATING_USER_LETTER + "_" + action.userletterId);
            state.userLetters =  state.userLetters.map((userletter) => {
                if(userletter.id !== action.userletterId){
                    return userletter;
                }
                return {...action.userletter}
            })
            return { ...state };
            
        case ActionTypes.FETCH_REFERENTS_REQUEST:
            if (!state.isLoading.includes(Loadings.FETCHING_REFERENTS)){
                state.isLoading.push(Loadings.FETCHING_REFERENTS);
            }
            return { ...state };
            
        case ActionTypes.FETCH_REFERENTS_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.FETCHING_REFERENTS);
            return { ...state };

        case ActionTypes.FETCH_REFERENTS_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.FETCHING_REFERENTS);
            state.referents = action.referents.map(l => new Referent(l));
            return { ...state };
            
            
        case ActionTypes.CREATE_REFERENT_REQUEST:
            if (!state.isLoading.includes(Loadings.CREATING_REFERENT)){
                state.isLoading.push(Loadings.CREATING_REFERENT);
            }
            return { ...state };
            
        case ActionTypes.CREATE_REFERENT_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.CREATING_REFERENT);
            return { ...state };

        case ActionTypes.CREATE_REFERENT_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.CREATING_REFERENT);
            state.referents = [...state.referents, new Referent(action.referent)];
            return { ...state };
            
        case ActionTypes.UPDATE_REFERENT_REQUEST:
            if (!state.isLoading.includes(Loadings.UPDATING_REFERENT)){
                state.isLoading.push(Loadings.UPDATING_REFERENT);
            }
            return { ...state };
            
        case ActionTypes.UPDATE_REFERENT_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.UPDATING_REFERENT);
            return { ...state };

        case ActionTypes.UPDATE_REFERENT_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.UPDATING_REFERENT);
            state.referents = state.referents.map((ref) => {
                if(ref.id !== action.referent.id){
                    return ref;
                }else{
                    return new Referent(action.referent)
                }
                    
                
            });
            return { ...state };
        case ActionTypes.DELETE_REFERENT_REQUEST:
            if (!state.isLoading.includes(Loadings.DELETING_REFERENT)){
                state.isLoading.push(Loadings.DELETING_REFERENT);
            }
            return { ...state };
            
        case ActionTypes.DELETE_REFERENT_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.DELETING_REFERENT);
            return { ...state };

        case ActionTypes.DELETE_REFERENT_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.DELETING_REFERENT);
            state.referents = state.referents.filter(r => r.id !== action.referentId)
            return { ...state };
            
        case ActionTypes.FETCH_USER_SERVICES_REQUEST:
            if (!state.isLoading.includes(Loadings.FETCHING_USER_CONNECTION)){
                state.isLoading.push(Loadings.FETCHING_USER_CONNECTION);
            }
            return { ...state };
        
        case ActionTypes.FETCH_USER_SERVICES_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.FETCHING_USER_CONNECTION);
            state.connectionTypes = action.data.map(c => new Service(c));
            return { ...state };

        case ActionTypes.FETCH_USER_SERVICES_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.FETCHING_USER_CONNECTION);
            return { ...state };

        case ActionTypes.ADD_USER_SERVICE_REQUEST:
            if (!state.isLoading.includes(Loadings.ADDING_USER_CONNECTION)){
                state.isLoading.push(Loadings.ADDING_USER_CONNECTION);
            }
            return { ...state };

        case ActionTypes.ADD_USER_SERVICE_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.ADDING_USER_CONNECTION);
            state.connectionTypes = [...state.connectionTypes, new Service(action.data)];
            return { ...state };

        case ActionTypes.ADD_USER_SERVICE_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.ADDING_USER_CONNECTION);
            return { ...state };

        case ActionTypes.DELETE_USER_SERVICE_REQUEST:
            if (!state.isLoading.includes(Loadings.REMOVING_USER_CONNECTION)){
                state.isLoading.push(Loadings.REMOVING_USER_CONNECTION);
            }
            return { ...state };

        case ActionTypes.DELETE_USER_SERVICE_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.REMOVING_USER_CONNECTION);
            state.connectionTypes = state.connectionTypes.filter(s => s.id !== action.service.id);
            state.serviceDatas = state.serviceDatas.filter(s => s.serviceType !== convertConnectionTypesToServiceType(action.service.connectionType));
            return { ...state };

        case ActionTypes.DELETE_USER_SERVICE_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.REMOVING_USER_CONNECTION);
            return { ...state };            

        case ActionTypes.SET_COMPLETE_USER_SERVICES_DATA_REQUEST:
            if (!state.isLoading.includes(Loadings.COMPLETING_USER_SERVICES_DATA)){
                state.isLoading.push(Loadings.COMPLETING_USER_SERVICES_DATA);
            }
            return { ...state };

        case ActionTypes.SET_COMPLETE_USER_SERVICES_DATA_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.COMPLETING_USER_SERVICES_DATA);
            return { ...state };

        case ActionTypes.SET_COMPLETE_USER_SERVICES_DATA_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.COMPLETING_USER_SERVICES_DATA);
            return { ...state };

        case ActionTypes.FETCH_ONBOARDINGUSER_REQUEST:
            if (!state.isLoading.includes(Loadings.FETCHING_USER)){
                state.isLoading.push(Loadings.FETCHING_USER);
            }

        case ActionTypes.FETCH_ONBOARDINGUSER_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.FETCHING_USER);
            state.user = new User(action.data);
            return { ...state };

        case ActionTypes.FETCH_ONBOARDINGUSER_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.FETCHING_USER);
            return { ...state };


        case ActionTypes.UPDATE_ONBOARDINGUSER_REQUEST:
            if (!state.isLoading.includes(Loadings.UPDATING_USER)){
                state.isLoading.push(Loadings.UPDATING_USER);
            }

        case ActionTypes.UPDATE_ONBOARDINGUSER_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.UPDATING_USER);
            const userResidenceAddress1 = {...state.user.userResidenceAddress};
            state.user = new User(action.data);
            state.user.userResidenceAddress = userResidenceAddress1;
            return { ...state };

        case ActionTypes.UPDATE_ONBOARDINGUSER_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.UPDATING_USER);
            return { ...state };            
            
        case ActionTypes.FETCH_ONBOARDINGUSER_ADDRESS_REQUEST:
            if (!state.isLoading.includes(Loadings.FETCHING_ONBOARDINGUSER_ADDRESS)){
                state.isLoading.push(Loadings.FETCHING_ONBOARDINGUSER_ADDRESS);
            }
            return { ...state };

        case ActionTypes.FETCH_ONBOARDINGUSER_ADDRESS_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.FETCHING_ONBOARDINGUSER_ADDRESS);
            const userResidenceAddress = action.addresses[0];
            userResidenceAddress.addressContract = addressContractToInt(userResidenceAddress.addressContract);
            userResidenceAddress.addressType = addressTypeToInt(userResidenceAddress.addressType);
            state.user = {...state.user, userResidenceAddress: userResidenceAddress};
            return { ...state };

        case ActionTypes.FETCH_ONBOARDINGUSER_ADDRESS_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.FETCHING_ONBOARDINGUSER_ADDRESS);
            return { ...state };

        case ActionTypes.FETCH_ONBOARDINGUSER_ADDRESS_REQUEST:
            if (!state.isLoading.includes(Loadings.FETCHING_ONBOARDINGUSER_ADDRESS)){
                state.isLoading.push(Loadings.FETCHING_ONBOARDINGUSER_ADDRESS);
            }
            return { ...state };              


        case ActionTypes.UPDATE_ONBOARDINGUSER_ADDRESS_REQUEST:
            if (!state.isLoading.includes(Loadings.UPDATING_USER)){
                state.isLoading.push(Loadings.UPDATING_USER);
            }

        case ActionTypes.UPDATE_ONBOARDINGUSER_ADDRESS_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.UPDATING_USER);
            state.user = {...state.user, userResidenceAddress: action.data};
            return { ...state };

        case ActionTypes.UPDATE_ONBOARDINGUSER_ADDRESS_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.UPDATING_USER);
            return { ...state };            
            
        case ActionTypes.ADD_USER_SERVICE_BATCH_REQUEST:
            if (!state.isLoading.includes(Loadings.ADDING_USER_CONNECTION_BATCH)){
                state.isLoading.push(Loadings.ADDING_USER_CONNECTION_BATCH);
            }
            return { ...state };

        case ActionTypes.ADD_USER_SERVICE_BATCH_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.ADDING_USER_CONNECTION_BATCH);
            state.connectionTypes = action.data.map(d => new Service(d));
            return { ...state };

        case ActionTypes.ADD_USER_SERVICE_BATCH_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.ADDING_USER_CONNECTION_BATCH);
            return { ...state };                  

        case ActionTypes.UPDATE_ONBOARDINGSTEP_REQUEST:
            if (!state.isLoading.includes(Loadings.UPDATING_USER_ONBOARDINGSTEP)){
                state.isLoading.push(Loadings.UPDATING_USER_ONBOARDINGSTEP);
            }
            return { ...state }; 

        case ActionTypes.UPDATE_ONBOARDINGSTEP_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.UPDATING_USER_ONBOARDINGSTEP);
            state.user = {...state.user, onBoardingStep: action.data};
            return { ...state };

        default:
            return state;
    }
}
export default DeathDeclarationReducer;